import { Link } from "react-router-dom";

import "./notfound.scss";

export default function NotFoundPage() {
  return (
    <div className="not-found-container">
    
      <h1 className="title">404 - Page Not Found</h1>
      <p className="message">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="home-button">Go Home</Link>
    </div>
  );
}